import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { GatewayCycleOverrideEntity } from "../../../entities/gateway/cycle-override.entity";
import { GatewayScriptOverrideEntity } from "../../../entities/gateway/script-override.entity";
import { AuthService } from "../../../services/auth.service";
import { BatchRepo } from "../../../repos";
import { Observable } from "rxjs";
import { AppengineEntityList } from "../../../noizu/structs/appengine-entity-list";
import { BatchEntity } from "../../../entities";
import { GatewayWifiAndMcuFirmwareReport } from "../../../entities/gateway/wifi-and-mcu-firmware.report.entity";
import { ToasterService } from "angular2-toaster";
import { ModalOptions } from "ngx-bootstrap/modal";
import { ManufacturerListService } from "app/services/manufacturers.service";

@Component({
  selector: "embed-wifi-and-mcu-report",
  template: `
    <div class="card border-danger">
      <div class="card-header bg-danger">
        Wifi & MCU Firmware ({{ entity?.wifi?.last_reported }},
        {{ entity?.mcu?.last_reported }})
        <div class="card-header-actions">
          <span
            class="pr-2 mx-1"
            style="cursor: pointer;"
            (click)="refreshData($event)"
          >
            <i class="fa fa-sm fa-refresh"></i>
          </span>
          <span class="pr-2"
            ><i
              (click)="expandCard = !expandCard"
              class="fa fa-sm"
              [ngClass]="{
                'fa-chevron-down': !expandCard,
                'fa-chevron-up': expandCard
              }"
            >
            </i
          ></span>
          <span class="dragula-handle"
            ><i class="dragula-handle text-black-50 fa fa-lg fa-arrows"></i
          ></span>
        </div>
      </div>
      <div class="card-body p-1" *ngIf="expandCard">
        <div class="row">
          <div class="col-6">
            <strong>Batch:</strong>
          </div>
          <div class="col-6">
            {{ entity?.wifi?.gateway_entity?.batch }}
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <strong>Manufacturer:</strong>
          </div>
          <div class="col-6">
            {{ entity?.wifi?.gateway_entity?.manufacturer }}
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <div class="card m-0 p-0 border-success">
              <div class="card-header m-0 p-0 bg-success text-center">Wifi</div>
              <div class="card-body m-0 p-0">
                <div class="row">
                  <div class="col-6">
                    <strong>Last Firmware:</strong>
                  </div>
                  <div class="col-6">
                    {{ entity?.wifi?.last_reported }}
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <strong>Assigned Firmware:</strong>
                  </div>
                  <div class="col-6" *ngIf="entity?.wifi?.assigned">
                    {{ entity?.wifi?.assigned?.firmware_version }}
                  </div>
                  <div class="col-6" *ngIf="!entity?.wifi?.assigned">
                    <b>None</b>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <strong>Pending Firmware:</strong>
                  </div>
                  <div class="col-6" *ngIf="entity?.wifi?.pending">
                    {{ entity?.wifi?.pending?.firmware_version }}
                  </div>
                  <div class="col-6" *ngIf="!entity?.wifi?.pending">
                    <b>None</b>
                  </div>
                </div>

                <div
                  class="row"
                  *ngIf="entity?.wifi?.roll_out && entity?.wifi?.pending"
                >
                  <div class="col-6">
                    <strong>Roll Out Group:</strong>
                  </div>
                  <div class="col-6">
                    {{ entity?.wifi?.roll_out?.roll_out_group }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card m-0 p-0 border-success">
              <div class="card-header m-0 p-0 bg-success text-center">MCU</div>
              <div class="card-body m-0 p-0">
                <div class="row">
                  <div class="col-6">
                    <strong>Last Firmware:</strong>
                  </div>
                  <div class="col-6">
                    {{ entity?.mcu?.last_reported }}
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <strong>Assigned Firmware:</strong>
                  </div>
                  <div class="col-6" *ngIf="entity?.mcu?.assigned">
                    {{ entity?.mcu?.assigned?.firmware_version }}
                  </div>
                  <div class="col-6" *ngIf="!entity?.mcu?.assigned">
                    <b>None</b>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <strong>Pending Firmware:</strong>
                  </div>
                  <div class="col-6" *ngIf="entity?.mcu?.pending">
                    {{ entity?.mcu?.pending?.firmware_version }}
                  </div>
                  <div class="col-6" *ngIf="!entity?.mcu?.pending">
                    <b>None</b>
                  </div>
                </div>

                <div
                  class="row"
                  *ngIf="entity?.mcu?.roll_out && entity?.mcu?.pending"
                >
                  <div class="col-6">
                    <strong>Roll Out Group:</strong>
                  </div>
                  <div class="col-6">
                    {{ entity?.mcu?.roll_out?.roll_out_group }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2 mb-2">
          <div class="col">
            <div class="card border-secondary m-0 p-0">
              <div class="card-header text-center m-0 p-0 bg-secondary">
                Gateway Internal State
              </div>
              <div class="card-body m-0 p-0">
                <div class="row">
                  <div class="col">
                    <div class="card m-0 p-0 border-success">
                      <div class="card-header m-0 p-0 bg-success text-center">
                        Wifi
                      </div>
                      <div class="card-body m-0 p-0">
                        <div class="row">
                          <div class="col-6"><strong>*assigned</strong></div>
                          <div
                            class="col-6"
                            *ngIf="entity?.wifi?.worker_state?.assigned_link"
                          >
                            {{ entity?.wifi?.worker_state?.assigned_link }}
                          </div>
                          <div
                            class="col-6"
                            *ngIf="!entity?.wifi?.worker_state?.assigned_link"
                          >
                            None
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6"><strong>*manager</strong></div>
                          <div
                            class="col-6"
                            *ngIf="entity?.wifi?.worker_state?.pending_release"
                          >
                            {{ entity?.wifi?.worker_state?.pending_release }}
                          </div>
                          <div
                            class="col-6"
                            *ngIf="!entity?.wifi?.worker_state?.pending_release"
                          >
                            None
                          </div>
                        </div>
                        <div
                          class="row"
                          *ngIf="entity?.wifi?.worker_state?.pending_release"
                        >
                          <div class="col-6">
                            <strong>*managed_link</strong>
                          </div>
                          <div class="col-6">
                            {{ entity?.wifi?.worker_state?.pending_link }}
                          </div>
                        </div>
                        <div
                          class="row"
                          *ngIf="entity?.wifi?.worker_state?.pending_release"
                        >
                          <div class="col-6">
                            <strong>*managed_phase</strong>
                          </div>
                          <div class="col-6">
                            {{ entity?.wifi?.worker_state?.pending_phase }}
                          </div>
                        </div>
                        <div
                          class="row"
                          *ngIf="entity?.wifi?.worker_state?.pending_release"
                        >
                          <div class="col-6">
                            <strong>*managed_step</strong>
                          </div>
                          <div class="col-6">
                            {{ entity?.wifi?.worker_state?.meta?.pending_step }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="card m-0 p-0 border-success">
                      <div class="card-header m-0 p-0 bg-success text-center">
                        MCU
                      </div>
                      <div class="card-body m-0 p-0">
                        <div class="row">
                          <div class="col-6"><strong>*assigned</strong></div>
                          <div
                            class="col-6"
                            *ngIf="entity?.mcu?.worker_state?.assigned_link"
                          >
                            {{ entity?.mcu?.worker_state?.assigned_link }}
                          </div>
                          <div
                            class="col-6"
                            *ngIf="!entity?.mcu?.worker_state?.assigned_link"
                          >
                            None
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6"><strong>*manager</strong></div>
                          <div
                            class="col-6"
                            *ngIf="entity?.mcu?.worker_state?.pending_release"
                          >
                            {{ entity?.mcu?.worker_state?.pending_release }}
                          </div>
                          <div
                            class="col-6"
                            *ngIf="!entity?.mcu?.worker_state?.pending_release"
                          >
                            None
                          </div>
                        </div>
                        <div
                          class="row"
                          *ngIf="entity?.mcu?.worker_state?.pending_release"
                        >
                          <div class="col-6">
                            <strong>*managed_link</strong>
                          </div>
                          <div class="col-6">
                            {{ entity?.mcu?.worker_state?.pending_link }}
                          </div>
                        </div>
                        <div
                          class="row"
                          *ngIf="entity?.mcu?.worker_state?.pending_release"
                        >
                          <div class="col-6">
                            <strong>*managed_phase</strong>
                          </div>
                          <div class="col-6">
                            {{ entity?.mcu?.worker_state?.pending_phase }}
                          </div>
                        </div>
                        <div
                          class="row"
                          *ngIf="entity?.mcu?.worker_state?.pending_release"
                        >
                          <div class="col-6">
                            <strong>*managed_step</strong>
                          </div>
                          <div class="col-6">
                            {{ entity?.mcu?.worker_state?.meta?.pending_step }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="entity?.wifi?.roll_out">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <strong>Release RollOut Record</strong>
              </div>
            </div>

            <div class="row">
              <div class="col-6"><strong>*phase</strong></div>
              <div class="col-6">{{ entity?.wifi?.roll_out?.phase }}</div>
            </div>
            <div class="row">
              <div class="col-6"><strong>*step</strong></div>
              <div class="col-6">{{ entity?.wifi?.roll_out?.step }}</div>
            </div>
            <div class="row">
              <div class="col-6"><strong>*status</strong></div>
              <div class="col-6">{{ entity?.wifi?.roll_out?.status }}</div>
            </div>

            <div class="row">
              <div class="col-6"><strong>*roll_out_group</strong></div>
              <div class="col-6">
                {{ entity?.wifi?.roll_out?.roll_out_group }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center">
            <button (click)="forceRefresh($event)" class="button btn-primary">
              Force Link Update
            </button>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-12 text-center">
            <strong>Cycle Override</strong>
          </div>
          <div class="col-12" *ngIf="!entity?.wifi?.cycle_override">[NONE]</div>
          <div class="col-12" *ngIf="entity?.wifi?.cycle_override">
            <div class="row">
              <div class="col-5">
                <strong>Enabled</strong>
              </div>
              <div class="col-7">
                {{ entity?.wifi?.cycle_override.enabled | json }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">
                <strong>Interval</strong>
              </div>
              <div class="col-7">
                {{ entity?.wifi?.cycle_override.interval }} (Seconds)
              </div>
            </div>
            <div class="row">
              <div class="col-5">
                <strong>VerString</strong>
              </div>
              <div class="col-7">
                <span *ngIf="entity?.wifi?.cycle_override.firmware_version">{{
                  entity?.wifi?.cycle_override.firmware_version
                }}</span>
                <span *ngIf="!entity?.wifi?.cycle_override.firmware_version"
                  >[No Override]</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center">
            <strong>Script Override</strong>
          </div>
          <div class="col-12" *ngIf="!entity?.wifi?.script_override">
            [No Firmware Script Enabled]
          </div>
          <div class="col-12" *ngIf="entity?.wifi?.script_override">
            <div class="row">
              <div class="col-5">
                <strong>Enabled</strong>
              </div>
              <div class="col-7">
                {{ entity?.wifi?.script_override.enabled | json }}
              </div>
            </div>

            <div class="row">
              <div class="col-5">
                <strong>Script</strong>
              </div>
              <div class="col-7">
                <pre>{{ entity?.wifi?.script_override.script | json }}</pre>
              </div>
            </div>

            <div class="row">
              <div class="col-5">
                <strong>Script Sequence Position</strong>
              </div>
              <div class="col-7">
                <pre>{{
                  entity?.wifi?.script_override.sequencer_info?.entity?.position
                }}</pre>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="overrideAccess()">
          <hr />
          <div class="row">
            <div class="col text-justify text-center">
              <button
                (click)="showSetCycle(reportModal, $event)"
                class="button btn-warning"
              >
                Assign Cycle
              </button>
            </div>
            <div class="col text-justify text-center">
              <button
                (click)="showSetScript(reportModal, $event)"
                class="button btn-danger"
              >
                Assign Script
              </button>
            </div>
            <div class="col text-justify text-center">
              <button
                (click)="showSetBatch(reportModal, $event)"
                class="button btn-primary"
              >
                Assign Batch
              </button>
            </div>
            <div class="col text-justify text-center">
              <button
                (click)="showSetBatch(reportModal, $event)"
                class="button btn-danger"
              >
                Force MOTA
              </button>
            </div>
            <div class="col text-justify text-center">
              <button
                (click)="showSetBatch(reportModal, $event)"
                class="button btn-success"
              >
                Set Ref
              </button>
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-12 text-center pr-4">
            <strong>Firmware Links</strong>
            <span class="float-right">
              <i
                (click)="expandLinks = !expandLinks"
                class="fa fa-sm"
                [ngClass]="{
                  'fa-chevron-down': !expandLinks,
                  'fa-chevron-up': expandLinks
                }"
              >
              </i>
            </span>
          </div>
          <div class="col-12" *ngIf="expandLinks">
            <pre>{{ entity?.wifi?.firmware_links | json }}</pre>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center pr-4">
            <strong>Firmware Report</strong>
            <span class="float-right">
              <i
                (click)="expandReport = !expandReport"
                class="fa fa-sm"
                [ngClass]="{
                  'fa-chevron-down': !expandReport,
                  'fa-chevron-up': expandReport
                }"
              >
              </i>
            </span>
          </div>
          <div class="col-12" *ngIf="expandReport">
            <pre>{{ entity?.wifi?.report | json }}</pre>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center pr-4">
            <strong>Extended History</strong>
            <span class="float-right">
              <i
                (click)="expandHistory = !expandHistory"
                class="fa fa-sm"
                [ngClass]="{
                  'fa-chevron-down': !expandHistory,
                  'fa-chevron-up': expandHistory
                }"
              >
              </i>
            </span>
          </div>
          <div class="col-12" *ngIf="expandHistory">
            <pre>{{ entity?.wifi?.history | json }}</pre>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center pr-4">
            <strong>Raw Internal State</strong>
            <span class="float-right">
              <i
                (click)="expandInternalState = !expandInternalState"
                class="fa fa-sm"
                [ngClass]="{
                  'fa-chevron-down': !expandInternalState,
                  'fa-chevron-up': expandInternalState
                }"
              >
              </i>
            </span>
          </div>
          <div class="col-12" *ngIf="expandInternalState">
            <pre>{{ entity?.wifi?.worker_state | json }}</pre>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center pr-4">
            <strong>Raw RollOut State</strong>
            <span class="float-right">
              <i
                (click)="expandRollOutState = !expandRollOutState"
                class="fa fa-sm"
                [ngClass]="{
                  'fa-chevron-down': !expandRollOutState,
                  'fa-chevron-up': expandRollOutState
                }"
              >
              </i>
            </span>
          </div>
          <div class="col-12" *ngIf="expandRollOutState">
            <pre>{{ entity?.wifi?.roll_out | json }}</pre>
          </div>
        </div>
      </div>
    </div>

    <!--                                                        -->
    <!--                    Pop-Up Menu                         -->
    <!--                                                        -->
    <ng-template #reportModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ currentModal?.title }}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="reportModalRef.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <widget-spinner *ngIf="currentModal?.processing"></widget-spinner>
        <div class="row">
          <div class="col-12">
            {{ currentModal?.msg }}
          </div>
        </div>
        <div class="row mb-3" *ngIf="currentModal?.errorMsg">
          <div class="col-12">
            <div
              class="alert alert-warning alert-dismissible fade show"
              role="alert"
            >
              {{ currentModal?.errorMsg }}
              <button
                type="button"
                class="close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
        <div class="row" [ngSwitch]="currentModal?.form">
          <div class="col-12" *ngSwitchCase="'batch'">
            <div class="card shadow-sm border-0">
              <div class="card-body">
                <h5 class="card-title mb-3">Assign Batch</h5>
                <div class="row mb-2" *ngIf="webDebugLevel >= 5">
                  <div class="col-12">
                    <div class="alert alert-warning mb-0" role="alert">
                      <strong>Warning:</strong> Your device Streaming Policy -&gt; web_debug_level is {{ webDebugLevel }}. To make assign batch work please set web_debug_level below 5.
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <label class="form-label fw-semibold mb-2"
                      >Select Batch</label
                    >
                    <ng-select
                      class="w-100"
                      [items]="batches"
                      [multiple]="false"
                      bindLabel="label"
                      bindValue="value"
                      placeholder="Choose a batch"
                      [(ngModel)]="editBatch.batch"
                      *ngIf="available.batches | async as batches"
                    ></ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12" *ngSwitchCase="'cycle'">
            <div class="form-group">
              <div class="row">
                <div class="col-4"><strong>Enabled</strong></div>
                <div class="col-4">
                  <input
                    type="checkbox"
                    class="form-control"
                    [(ngModel)]="editCycle.enabled"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-4"><strong>Interval</strong></div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="editCycle.interval"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-4"><strong>Spoof Version</strong></div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="editCycle.firmware_version"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12" *ngSwitchCase="'script'">
            <div class="form-group">
              <div class="row">
                <div class="col-4"><strong>Enabled</strong></div>
                <div class="col-4">
                  <input
                    type="checkbox"
                    class="form-control"
                    [(ngModel)]="editScript.enabled"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-4"><strong>Script</strong></div>
                <div class="col-4">
                  <select
                    class="form-control font-xl pb-0 pt-0"
                    [(ngModel)]="editScript.script"
                  >
                    <option [value]="'alpha_group'">Alpha Group</option>
                    <option [value]="'beta_group'">Beta Group</option>
                    <option [value]="'dev_group'">Dev Group</option>
                    <option [value]="'noizu_group'">Noizu Group</option>
                    <option [value]="'v3_group'">V3 1024kb+ Beta Group</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" *ngSwitchDefault>[Unsupported Modal Type]</div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-warning"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg"
          type="button"
          class="btn btn-danger"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>
  `,
})
export class EmbedWifiAndMcuReportComponent implements OnInit {
  @Input() entity: GatewayWifiAndMcuFirmwareReport = null;
  @Input() options: any = null;
  @Input() layout: string = null;
  @Input() streamingPolicy: any[] = null;

  get webDebugLevel(): number {
    if (!this.streamingPolicy) return null;
    const entry = this.streamingPolicy.find(p => p.key === 'web_debug_level');
    return entry ? Number(entry.value) : null;
  }

  public expandCard = false;
  public editCycle = new GatewayCycleOverrideEntity(null);
  public editScript = new GatewayScriptOverrideEntity(null);
  public editBatch = { batch: 12 };

  public reportModalRef: BsModalRef;
  public currentModal: any;

  public available = {
    batches: null,
    types: null,
    firmware: null,
    manufacturers: [],
    series: [
      { value: "V2", label: "V2" },
      { value: "V3", label: "V3" },
      { value: "V4", label: "V4" },
    ],
  };

  public setCycleModal = {
    title: "Set Cycle Override",
    msg: `This will force the Display to regularly check for Firmware Updates.`,
    errorMsg: null,
    processing: false,
    form: "cycle",
    confirmMsg: "Assign",
    confirm: () => {
      if (this.setCycle()) {
        this.reportModalRef.hide();
      }
    },
    deleteMsg: "Clear",
    delete: () => {
      if (this.clearCycle()) {
        this.reportModalRef.hide();
      }
    },
    cancelMsg: "Cancel",
    cancel: () => {
      this.setCycleModal.errorMsg = null;
      this.reportModalRef.hide();
    },
  };

  public setBatchModal = {
    title: "Set Batch",
    msg: `Update Display Assigned Batch and Force Firmware Check`,
    errorMsg: null,
    processing: false,
    form: "batch",
    confirmMsg: "Set",
    confirm: () => {
      if (this.setBatch()) {
        this.reportModalRef.hide();
      }
    },
    cancelMsg: "Cancel",
    cancel: () => {
      this.setBatchModal.errorMsg = null;
      this.reportModalRef.hide();
    },
  };

  public setScriptModal = {
    title: "Set Script Override",
    msg: `This will assign the display to an OTA sequence script.`,
    errorMsg: null,
    processing: false,
    form: "script",
    confirmMsg: "Assign",
    confirm: () => {
      if (this.setScript()) {
        this.reportModalRef.hide();
      }
    },
    deleteMsg: "Clear",
    delete: () => {
      if (this.clearScript()) {
        this.reportModalRef.hide();
      }
    },
    cancelMsg: "Cancel",
    cancel: () => {
      this.setScriptModal.errorMsg = null;
      this.reportModalRef.hide();
    },
  };

  public expandHistory = false;
  public expandLinks = false;
  public expandReport = false;
  public expandInternalState = false;
  public expandRollOutState = false;
  constructor(
    public modalService: BsModalService,
    public authService: AuthService,
    public repoBatches: BatchRepo,
    public toasterService: ToasterService,
    public manufacturerListService: ManufacturerListService
  ) {}

  //-----------------------------
  //
  //-----------------------------
  ngOnInit(): void {
    this.manufacturerListService.getManufacturers().then((res) => {
      this.available.manufacturers = res.map((m) => {
        return {
          value: `ref.manufacturer.${m.identifier}`,
          label: `${m.name}`,
        };
      });
    });
    this.available.batches = new Observable<any>((observer) => {
      this.repoBatches.getListPromise().then((v: AppengineEntityList) => {
        const response = [];
        v.items.forEach((i: BatchEntity) => {
          const entry = {
            value: i.identifier,
            label: `${i.identifier} - ${i.name}`,
          };
          response.push(entry);
        });
        observer.next(response);
      });
    });
  }

  refreshData(e) {
    e.preventDefault();
    this.entity.wifi
      .refreshData(this.entity.mcu)
      .then((data) => {
        this.toasterService.pop("success", "Firmware", "Refresh Data Complete");
      })
      .catch((err) => {
        this.toasterService.pop("error", "Firmware", "Failed to refresh data");
      });
  }

  overrideAccess() {
    return (
      this.authService.userHasPermission("firmware_admin") ||
      this.authService.userHasPermission("firmware_assign")
    );
  }

  showSetCycle(reportModal, event) {
    event.preventDefault();
    this.currentModal = this.setCycleModal;
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.reportModalRef = this.modalService.show(reportModal, config);
  }

  setCycle() {
    this.setCycleModal.errorMsg = null;
    if (typeof this.editCycle.interval === "string") {
      this.editCycle.interval = this.editCycle.interval.trim();
      const t = Number(this.editCycle.interval);
      if (t.toString() !== this.editCycle.interval) {
        this.setCycleModal.errorMsg = "Interval Must Be Whole Number";
        return false;
      }
      this.editCycle.interval = t;
    }

    if (Number.isInteger(this.editCycle.interval)) {
      if (this.editCycle.enabled) {
        this.editCycle.enabled = true;
      } else {
        this.editCycle.enabled = false;
      }
      if (typeof this.editCycle.firmware_version === "string") {
        if (this.editCycle.firmware_version.length > 10) {
          this.setCycleModal.errorMsg =
            "Firmware String Must Be 10 chars or less.";
          return false;
        }
        if (this.editCycle.firmware_version === "") {
          this.editCycle.firmware_version = null;
        }
      }
    } else {
      this.setCycleModal.errorMsg = "Interval Must Be Whole Number";
      return false;
    }

    this.setCycleModal.processing = true;
    this.entity.wifi.setCycle(this.editCycle).then((d) => {
      this.toasterService.pop("success", "Firmware", `Refresh Cycle Updated.`);
      this.setCycleModal.processing = false;
      this.reportModalRef.hide();
    });
    return false;
  }

  clearCycle() {
    this.setScriptModal.errorMsg = null;
    this.setCycleModal.processing = true;
    this.entity.wifi.clearCycle().then((d) => {
      this.toasterService.pop("warning", "Firmware", `Refresh Cycle Removed.`);
      this.setCycleModal.processing = false;
      this.reportModalRef.hide();
    });
    return false;
  }

  showSetScript(reportModal, event) {
    event.preventDefault();
    this.currentModal = this.setScriptModal;
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.reportModalRef = this.modalService.show(reportModal, config);
  }

  setScript() {
    if (this.editScript.script) {
      if (this.editScript.enabled) {
        this.editScript.enabled = true;
      } else {
        this.editScript.enabled = false;
      }
      this.setScriptModal.processing = true;
      this.entity.wifi.setScript(this.editScript).then((d) => {
        this.toasterService.pop("success", "Firmware", `Override Script Set.`);
        this.setScriptModal.processing = false;
        this.reportModalRef.hide();
      });
    } else {
      this.setScriptModal.errorMsg = "Must select script";
    }
    return false;
  }

  clearScript() {
    this.setScriptModal.errorMsg = null;
    this.setScriptModal.processing = true;
    this.entity.wifi.clearScript().then((d) => {
      this.toasterService.pop(
        "success",
        "Firmware",
        `Override Script Removed.`
      );
      this.setScriptModal.processing = false;
      this.reportModalRef.hide();
    });
    return false;
  }

  showSetBatch(reportModal, event) {
    event.preventDefault();
    this.currentModal = this.setBatchModal;
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.reportModalRef = this.modalService.show(reportModal, config);
  }

  forceRefresh(event) {
    event.preventDefault();
    this.entity.wifi.forceRefresh().then(() => {
      this.toasterService.pop(
        "success",
        "Firmware",
        `Force Link Update Complete`
      );
    });
  }

  setBatch() {
    this.setBatchModal.errorMsg = null;
    if (this.editBatch.batch) {
      this.setBatchModal.processing = true;
      this.entity.wifi.setBatch(this.editBatch).then((d) => {
        this.toasterService.pop(
          "success",
          "Firmware",
          `Batch has been updated.`
        );
        this.setBatchModal.processing = false;
        this.reportModalRef.hide();
      });
    } else {
      this.setBatchModal.errorMsg = "You must select batch";
    }
    return false;
  }
}
